var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))]),_c('v-list-item-subtitle',{staticClass:"text-wrap"},[_vm._v(_vm._s(_vm.description))])],1)],1)],1),_c('v-col',{attrs:{"cols":"6"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }